import { IFilterConfigItem } from '@/bundles/GroupFilters/interfaces/IFilterConfigItem';
import { FilterCategoryEnum, FilterTypeEnum } from '@/bundles/GroupFilters/enums/FilterTypeEnum';
import { getShowArchiveFilterConfig } from '@/bundles/GroupFilters/helpers/filtersConfig/getShowArchiveFilterConfig';

export const getSavedSetFilters = (): IFilterConfigItem[] => {
  return [
    // FilterCategoryEnum.saved_set_details start
    {
      title: 'Record / Section',
      name: 'set_section',
      type: FilterTypeEnum.autocomplete_multiple_select,
      items: [
        { text: 'Company', value: 'company' },
        { text: 'Contact', value: 'contact' },
        { text: 'Occupier', value: 'occupier' },
        { text: 'Requirement', value: 'requirement' },
        { text: 'Property', value: 'property' },
        { text: 'Availability', value: 'availability' },
        { text: 'Comparable', value: 'comparable' },
        { text: 'Project', value: 'project' },
        { text: 'Saved Set', value: 'savedset' },
        { text: 'Pipeline', value: 'pipeline' },
        { text: 'Deal', value: 'deal' },
        { text: 'Marketing', value: 'marketing' }
      ],
      category: FilterCategoryEnum.saved_set_details,
    },
    {
      title: 'Featured',
      name: 'set_featured',
      type: FilterTypeEnum.switch,
      category: FilterCategoryEnum.saved_set_details,
    },
    {
      title: 'System Set',
      name: 'is_system_set',
      type: FilterTypeEnum.switch,
      category: FilterCategoryEnum.saved_set_details,
    },
    {
      title: 'Portfolio Filter',
      name: 'portfolio_filter',
      type: FilterTypeEnum.switch,
      category: FilterCategoryEnum.saved_set_details,
    },
    // FilterCategoryEnum.saved_set_details end
    // FilterCategoryEnum.created_edited start
    {
      title: 'Created/Edited Date',
      name: 'set_view_date',
      type: FilterTypeEnum.date_range,
      category: FilterCategoryEnum.created_edited,
    },
    {
      title: 'Created Date',
      name: 'set_created_date',
      type: FilterTypeEnum.date_range,
      category: FilterCategoryEnum.created_edited,
    },
    {
      title: 'Edited Date',
      name: 'set_edited_date',
      type: FilterTypeEnum.date_range,
      category: FilterCategoryEnum.created_edited,
    },
    {
      title: 'Created/Edited by',
      name: 'set_view',
      type: FilterTypeEnum.create_updated_by_select,
      category: FilterCategoryEnum.created_edited,
    },
    {
      title: 'Created by',
      name: 'set_created_by',
      type: FilterTypeEnum.create_updated_by_select,
      category: FilterCategoryEnum.created_edited,
    },
    {
      title: 'Edited by',
      name: 'set_edited_by',
      type: FilterTypeEnum.create_updated_by_select,
      category: FilterCategoryEnum.created_edited,
    },
    // FilterCategoryEnum.created_edited end
    getShowArchiveFilterConfig(),
  ].filter(Boolean) as IFilterConfigItem[];
};
